export default {
	state: {
		profile: null,
		friends: null,
		activeAccountIndex: null,  // which account we
		accounts: [] // { jwt, name, screen_name, image_url }
	},
	reducer: (state) => ({
		// profile: state.auth.profile,
		accounts: state.auth.accounts,
		activeAccountIndex: state.auth.activeAccountIndex,
	}),
	getters: {
		activeAccount: (state) => {
			return state.activeAccountIndex === null ? null : state.accounts[state.activeAccountIndex]
		},
		isLoggedIn: (state, getters) => {
			// explicitly logged in - returns false if loading
			return getters.activeAccount !== null
		}
	},
	
	mutations: {
		
		clearProfile(state) {
			state.profile = null
			state.friends = null
		},
		
		setProfile(state, profile) {
			state.profile = profile
			state.friends = null
		},
		
		clearFriends(state) {
			state.friends = null
		},
		
		setFriends(state, friends) {
			state.friends = friends
		},
		
		setActiveAccountIndex(state, index) {
			state.activeAccountIndex = index
			if (index === null) {
				state.profile = null
			}
		},
		
		addNewAccount(state, account) {
			state.accounts.push(account)
			state.activeAccountIndex = state.accounts.length - 1  // activate new account
		},
		
		updateAccount(state, {index, account}) {
			state.accounts[index] = account
		},
		
		updateAccountJWT(state, {index, jwt}) {
			state.accounts[index].jwt = jwt
		},
		
		updateActiveAccountJWT(state, jwt) {
			state.accounts[state.activeAccountIndex].jwt = jwt
		},
		
		deleteAccount(state, index) {
			state.accounts.splice(index, 1)
			state.activeAccountIndex = null
		}
	},
	actions: {
		// Inserts or updates an account record; checks for existence based on screen_name
		storeAccount({state, commit}, {jwt, name, screen_name, image_url}) {
			let account = {jwt, name, screen_name, image_url}
			let index = state.accounts.findIndex(account => account.screen_name === screen_name)
			if (index > -1) {
				commit('updateAccount', {index, account})
				commit('setActiveAccountIndex', index)
			} else {
				commit('addNewAccount', account)
			}
		}
	}
	
}
